const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  USDC_USDT: "0x4b1f1e2435a9c96f7330faea190ef6a7c8d70001",
  USDC_WETH: "0x34965ba0ac2451a34a0471f04cca3f990b8dea27",
  WMATIC_WETH: "0xc4e595acdd7d12fec385e5da5d43160e8a0bac0e"
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.WMATIC_WETH]: 0,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_WETH]: 1,
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_USDT]: 8
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_USDT]]: ["0x0b3f868e0be5597d5db7feb59e1cadbb0fdda50a", "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDC_USDT]: 2,
};

module.exports = {
  ADDRESS: "0x0769fd68dfb93167989c6f7254cd0d766fb2841f",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
